import(/* webpackMode: "eager", webpackExports: ["OrganizeLocallyCompoenent"] */ "/app/src/components/nivaran/organize/OrganizeLocallyComponent.tsx");
